import { render, staticRenderFns } from "./ParentMenu.vue?vue&type=template&id=2da65492"
import script from "./ParentMenu.vue?vue&type=script&lang=js"
export * from "./ParentMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports